/** Single source of truth for the supplier-declarations flow's route paths. */
import {
  DEFAULT_STUDIO_V2_URL,
  studioV2Search,
} from "./review/studio-v2/studioV2Url"

export const DECLARATIONS_BASE =
  "/material-compliance/supplier-studio/declarations"

export const declarationImportPath = `${DECLARATIONS_BASE}/import`

/**
 * ONE DECLARATION'S REVIEW, optionally addressed at a statement. The address lives
 * in the review studio's own query string (`studioV2Url.ts`), so this composes its
 * serializer. A statement address expands its card; no worklist step is named, so
 * a link never triggers the studio's step jump.
 */
export interface DeclarationReviewAddress {
  statementId?: string | null
}

export function declarationReviewPath(
  declarationId: string,
  address: DeclarationReviewAddress = {},
): string {
  const search = studioV2Search({
    ...DEFAULT_STUDIO_V2_URL,
    statementId: address.statementId ?? null,
  })
  return `${DECLARATIONS_BASE}/${declarationId}/review${search}`
}

/**
 * Task 6 — the open-sibling hint's deep link: this supplier's OTHER open
 * declarations. `lifecycle=pending,processing,ready` is the exact three-value
 * set `open_sibling_count` counts (`open_review_predicate`, backend
 * mc_declaration_repository.py) — the same list-page params Task 3/F4 already
 * wires up (`supplier_id` singular deep-link + `lifecycle` CSV facet).
 */
export function openSiblingDeclarationsPath(supplierId: string): string {
  const params = new URLSearchParams({
    supplier_id: supplierId,
    lifecycle: "pending,processing,ready",
  })
  return `${DECLARATIONS_BASE}?${params.toString()}`
}
